import { useQuery } from '@tanstack/react-query';
// Service
import { getCustomers } from './customersService';

/**
 * @description Get the list of customers.
 * @param {object} queryParams
 * @param {string} [queryParams.sort]
 * @param {string} [queryParams.order]
 * @param {number} [queryParams.pageNumber]
 * @param {number} [queryParams.pageSize]
 * @param {string} [queryParams.search]
 * @param {string} [queryParams.status]
 * @param {string} [queryParams.brokerIds]
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {total: number, page: number, data: Customer[]}, Error>}
 */
export const useGetCustomerListQuery = (queryParams, options) => useQuery({
  queryKey: ['admin-customers', queryParams],
  queryFn: () => getCustomers(queryParams),
  ...options,
});
